import ValidationInterface from "@/plans/common/validation-interface";
import { bizPlusCategories, proPlusCategories, USCallingCategories } from "@/common/persist-cart/categories";

export default class extends ValidationInterface {
  async requires(cart) {
    const deskPhoneCategories = cart.planMap.filter((p) => p.type === "zoom_device$desk_phone").map(p => p.category);
    return [this.current(deskPhoneCategories).require([...USCallingCategories, ...proPlusCategories, ...bizPlusCategories])];
  }

  async conflicts() {
    return [];
  }
}
